/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_FailedInputs */

const cs_auth_login_failed = /** @type {(inputs: Auth_Login_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášení se nezdařilo`)
};

const en_auth_login_failed = /** @type {(inputs: Auth_Login_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in failed`)
};

/**
* | output |
* | --- |
* | "Sign-in failed" |
*
* @param {Auth_Login_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_login_failed = /** @type {((inputs?: Auth_Login_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_login_failed(inputs)
	return cs_auth_login_failed(inputs)
});